var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93457 8.82617H7.65921H29.4563",
    stroke: "#5B5B5B",
    strokeWidth: 2.72464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7316 8.82623V27.8987C26.7316 28.6213 26.4446 29.3143 25.9336 29.8253C25.4226 30.3363 24.7296 30.6233 24.007 30.6233H10.3838C9.6612 30.6233 8.96818 30.3363 8.45721 29.8253C7.94624 29.3143 7.65918 28.6213 7.65918 27.8987V8.82623M11.7461 8.82623V6.10159C11.7461 5.37897 12.0332 4.68595 12.5442 4.17498C13.0551 3.66401 13.7482 3.37695 14.4708 3.37695H19.92C20.6427 3.37695 21.3357 3.66401 21.8467 4.17498C22.3576 4.68595 22.6447 5.37897 22.6447 6.10159V8.82623",
    stroke: "#5B5B5B",
    strokeWidth: 2.72464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4707 15.6377V23.8116",
    stroke: "#5B5B5B",
    strokeWidth: 2.72464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9199 15.6377V23.8116",
    stroke: "#5B5B5B",
    strokeWidth: 2.72464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ee6076caffa63619fe50aedde8e9d012.svg";
export { ForwardRef as ReactComponent };